/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const a = (r, t, e) => (e.configurable = !0, e.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(r, t, e), e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function i(r, t) {
  return (e, u, f) => {
    const c = (l) => {
      var o, n;
      return (n = (o = l.renderRoot) == null ? void 0 : o.querySelector(r)) != null ? n : null;
    };
    return a(e, u, { get() {
      return c(this);
    } });
  };
}
export {
  a,
  i as e
};
